import React, { useContext } from "react";
import { Checkbox } from "@mui/material";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";

const SelectMessageCheckbox = ({ message }) => {
    const { showSelectMessageCheckbox, setSelectedMessages, selectedMessages } =
        useContext(ForwardMessageContext);
    const initialChecked = React.useMemo(
        () => selectedMessages.some((m) => m.id === message.id),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
    const [isChecked, setIsChecked] = React.useState(initialChecked);
    const handle = (e) => {
        const list = selectedMessages;
        if (e.target.checked) {
            setIsChecked(true);
            if (!list.some((m) => m.id === message.id)) list.push(message);
        } else {
            setIsChecked(false);
            const idx = list.findIndex((m) => m.id === message.id);
            if (idx >= 0) list.splice(idx, 1);
        }
        setSelectedMessages(list);
    };
    if (!showSelectMessageCheckbox) return null;
    return (
        <Checkbox
            size="small"
            color="primary"
            checked={isChecked}
            onChange={handle}
            style={{ padding: 4 }}
        />
    );
};

export default SelectMessageCheckbox;
